module.exports = __webpack_public_path__ + "static/media/Jinali-Shah.151de850.png";